/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Hero_H1_EmInputs */

const es_l6_hero_h1_em = /** @type {(inputs: L6_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gestionado.`)
};

const gl_l6_hero_h1_em = /** @type {(inputs: L6_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`xestionado.`)
};

const en_l6_hero_h1_em = /** @type {(inputs: L6_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`managed.`)
};

/**
* | output |
* | --- |
* | "managed." |
*
* @param {L6_Hero_H1_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_hero_h1_em = /** @type {((inputs?: L6_Hero_H1_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Hero_H1_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_hero_h1_em(inputs)
	if (locale === "en") return en_l6_hero_h1_em(inputs)
	return es_l6_hero_h1_em(inputs)
});